import PropTypes from "prop-types";
import { Button, Modal } from "react-bootstrap";

const ESignLaunchModal = ({ show, onCancel, onConfirm }) => (
  <Modal
    show={show}
    onHide={onCancel}
    centered
    backdrop="static"
    contentClassName="custom-modal-new-provider-esign-launch"
    style={{ zIndex: 1000000, backdropFilter: show ? "contrast(0.5)" : "" }}
  >
    <Modal.Header className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center">
      <Modal.Title
        className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
        style={{ fontSize: "14px" }}
      >
        Electronic Signature
      </Modal.Title>
    </Modal.Header>
    <Modal.Body className="p-3 text-center">
      <p className="m-0 font-weight-semibold">
        The Electronic Signature document creation system will now open in a separate tab.
      </p>
    </Modal.Body>
    <Modal.Footer className="p-1 mt-0 d-flex justify-content-between" style={{ borderTop: 0 }}>
      <Button type="button" variant="secondary" className="height-25 py-0" onClick={onCancel}>
        Cancel
      </Button>
      <Button type="button" variant="success" className="height-25 py-0" onClick={onConfirm}>
        Open E-Sign
      </Button>
    </Modal.Footer>
  </Modal>
);

ESignLaunchModal.propTypes = {
  show: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};

ESignLaunchModal.defaultProps = {
  show: false,
  onCancel: () => {},
  onConfirm: () => {},
};

export default ESignLaunchModal;
